import { EmptyCell } from '../../formatters/genericFormatters';
import { useSpeedText } from '../../formatters/numberFormatters';

export function SpeedRenderer({ value }: { value: number | null | undefined }): string {
  const getSpeedText = useSpeedText();
  return typeof value === 'number' ? getSpeedText(value) : EmptyCell;
}

export default SpeedRenderer;
